import api from './api';

export const newsService = {
  // Get all news
  getAll: async (type = null, includeInactive = false) => {
    const params = {};
    if (type) params.type = type;
    if (includeInactive) params.includeInactive = includeInactive;
    
    const response = await api.get('/news', { params });
    return response.data;
  },

  // Get recent news
  getRecent: async (limit = 5) => {
    const response = await api.get('/news/recent', {
      params: { limit },
    });
    return response.data;
  },

  // Get pinned news
  getPinned: async () => {
    const response = await api.get('/news/pinned');
    return response.data;
  },

  // Search news
  search: async (query) => {
    const response = await api.get('/news/search', {
      params: { q: query },
    });
    return response.data;
  },

  // Get news by ID
  getById: async (id) => {
    const response = await api.get(`/news/${id}`);
    return response.data;
  },

  // Get news by slug
  getBySlug: async (slug) => {
    const response = await api.get(`/news/slug/${slug}`);
    return response.data;
  },

  // Create news (admin)
  create: async (data) => {
    const response = await api.post('/news', data);
    return response.data;
  },

  // Update news (admin)
  update: async (id, data) => {
    const response = await api.put(`/news/${id}`, data);
    return response.data;
  },

  // Delete news (admin)
  delete: async (id) => {
    const response = await api.delete(`/news/${id}`);
    return response.data;
  },
};

export default newsService;
